<template>
    <div ref="page-pc" :class="rootClass" class="page-pc" :style="rootStyle">
        <renderer v-for="v of mergeState" :tpl="v" class="page-pc-child" :key="v.id" :style="setStyle(v)"></renderer>
    </div>
</template>
<script>
import * as R from 'ramda';
const { renderer, store: { variable } } = window.FEGORender;
const { state: { initCmpStateMatchine } } = window.FEGOUtils;
import core from './core.vue';

export default {
    name: 'page-pc',
    extends: core,
    components: { renderer: renderer },
    computed: {
        //合并状态机
        mergeState() {
            //TODO 每次修改状态都会变更整个children，待优化
            return this.tpl.children.map((tpl, i) => {
                return R.mergeDeepRight(tpl, initCmpStateMatchine(tpl, variable.data));
            });
        },
        rootStyle() {
            return this.setStyle(this.tpl);
        }
    }
};
</script>
<style lang="less" scoped>
.page-pc {
    height: auto !important;
    width: 100% !important;
    max-width: 19.2rem !important;
    min-width: 12rem !important;
    margin: auto;
}

.page-pc-child {
    width: 100%;
    min-width: 12rem !important;
}
</style>



// WEBPACK FOOTER //
// src/render/index.vue